// @ts-nocheck

import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketImportItems } from '../../../../actions/basket';
import { send } from '../../../../actions/network';
import useMergeProps from '../../../../hooks/useMergeProps';
import { makeEntitiesBetslipsEntityStateByBetslipRefSelector } from '../../../../selectors/betslip.selector';
import { useBetslipOptionsContext } from '../../context/BetslipOptionsContext';
import { makeSelectBets } from '../../selectors/bets.selector';
import { selectOutcomesByOutcomesIdsProps } from '../BetslipOptionsAddToBasketModal/BetslipOtpionsAddToBasketModal.selector';

import BetslipOptionsAddToBasketItem from './BetslipOptionsAddToBasketItem';

const BetslipOptionsAddToBasketItemContainer = () => {
  const { uuid, betslipRef, onCloseModal, isFromHistory } = useBetslipOptionsContext();

  const dispatch = useDispatch();
  const getBetslip = useCallback(
    (betslipReference) => dispatch(send({ getOneBetslip: { betslipReference } })),
    [dispatch],
  );

  const betslipSelector = useMemo(() => makeEntitiesBetslipsEntityStateByBetslipRefSelector(), []);
  const betslip = useSelector((state) => betslipSelector(state, { betslipReference: betslipRef }));

  const selectorProps = useMemo(() => ({ outcomeIds: betslip?.details?.map((d) => d?.outcomeId) }), [betslip?.details]);
  const outcomes = useSelector((state) => selectOutcomesByOutcomesIdsProps(state, selectorProps));

  const { bets } = useSelector((state) => makeSelectBets(state, { outcomes }));

  useEffect(() => {
    getBetslip(betslipRef);
  }, [betslipRef, getBetslip]);

  const onAddToBasketClick = useCallback(() => {
    dispatch(
      basketImportItems({
        items: bets,
        isRepeatBet: true,
        isFromHistory,
        betslipReference: betslipRef,
        sourceElementUuid: uuid,
      }),
    );

    if (onCloseModal) {
      onCloseModal();
    }
  }, [bets, betslipRef, dispatch, isFromHistory, onCloseModal, uuid]);

  const otherProps = useMemo(() => ({ onClick: onAddToBasketClick }), [onAddToBasketClick]);

  const enhancedProps = useMergeProps({ otherProps });

  return <BetslipOptionsAddToBasketItem {...enhancedProps} />;
};

export default BetslipOptionsAddToBasketItemContainer;
